(function () {
  if (window.ncbStorefrontAnalytics) return;

  function cleanSectionId(value) {
    return value ? String(value).replace(/^shopify-section-/, '') : undefined;
  }

  function getSectionId(element) {
    const owner = element.closest('[data-section-id]');
    if (owner && owner.dataset.sectionId) return cleanSectionId(owner.dataset.sectionId);
    const section = element.closest('[id^="shopify-section-"]');
    return section ? cleanSectionId(section.id) : undefined;
  }

  function getCardPosition(element) {
    const positioned = element.closest('[data-card-position]');
    if (positioned && positioned.dataset.cardPosition) {
      const position = Number(positioned.dataset.cardPosition);
      return Number.isFinite(position) && position > 0 ? position : undefined;
    }

    const item = element.closest('li.grid__item, li');
    if (!item || !item.parentElement) return undefined;
    const siblings = Array.from(item.parentElement.children).filter(function (sibling) {
      return sibling.matches('li');
    });
    const index = siblings.indexOf(item);
    return index >= 0 ? index + 1 : undefined;
  }

  function getSurface(element) {
    if (element.closest('quick-add-modal')) return 'quick_add_modal';
    if (element.closest('.complementary-products')) return 'complementary_products';
    if (element.closest('.related-products')) return 'native_recommendations';

    const section = element.closest('[id^="shopify-section-"]');
    if (section && section.id.indexOf('featured_product') !== -1) return 'featured_product';
    if (element.closest('product-info')) return 'product_page';

    if (element.closest('.product-card-wrapper')) {
      if (window.location.pathname === '/') return 'homepage_quick_add';
      if (window.location.pathname.indexOf('/collections/') === 0) return 'collection_quick_add';
      if (window.location.pathname.indexOf('/search') === 0) return 'search_quick_add';
      return 'product_card_quick_add';
    }

    return 'unknown';
  }

  function getAddContext(element) {
    try {
      return {
        add_to_cart_surface: element ? getSurface(element) : 'unknown',
        section_id: element ? getSectionId(element) : undefined,
        card_position: element ? getCardPosition(element) : undefined,
        page_path: window.location.pathname,
      };
    } catch (error) {
      return {
        add_to_cart_surface: 'unknown',
        section_id: undefined,
        card_position: undefined,
        page_path: undefined,
      };
    }
  }

  function getViewportClass() {
    if (window.innerWidth < 750) return 'mobile';
    if (window.innerWidth < 990) return 'tablet';
    return 'desktop';
  }

  function isCaptureAllowed() {
    if (window.location.hostname !== 'nottawacottagebookstore.ca') return false;
    if (window.Shopify && window.Shopify.designMode) return false;
    var previewMeta = document.querySelector('meta[name="ncb-analytics-preview"]');
    if (previewMeta && previewMeta.content === 'true') return false;
    return Boolean(window.posthog && typeof window.posthog.capture === 'function');
  }

  function capture(name, properties) {
    try {
      if (!isCaptureAllowed()) return;
      window.posthog.capture(name, Object.assign({}, properties || {}, {
        page_path: window.location.pathname,
        viewport_class: getViewportClass(),
      }));
    } catch (error) {}
  }

  function buildAddToCartProperties(element, response) {
    return Object.assign({
      product_id: response.product_id,
      product_title: response.product_title,
      variant_id: response.id,
      variant_title: response.variant_title,
      quantity: response.quantity,
      price: response.price / 100,
      sku: response.sku,
    }, getAddContext(element));
  }

  function productHandleFromLink(link) {
    const path = new URL(link.href, window.location.origin).pathname;
    const match = path.match(/^\/products\/([^/]+)/);
    return match ? decodeURIComponent(match[1]) : undefined;
  }

  function trackProductCardClick(event) {
    const link = event.target.closest('a');
    if (!link || !link.closest('.product-card-wrapper')) return;
    const productHandle = productHandleFromLink(link);
    if (!productHandle) return;
    const context = getAddContext(link);
    capture('product_card_clicked', {
      product_handle: productHandle,
      section_id: context.section_id,
      card_position: context.card_position,
    });
  }

  function trackBestSellerLinkClick(event) {
    const link = event.target.closest('a');
    if (!link || !link.dataset || typeof link.dataset.ncbBestSellerLink === 'undefined') return;
    const position = Number(link.dataset.position);
    capture('best_seller_link_clicked', {
      product_handle: link.dataset.productHandle || undefined,
      position: Number.isFinite(position) && position > 0 ? position : undefined,
      section_id: getSectionId(link),
    });
  }

  function getBulletinArticleProperties(root) {
    if (!root || !root.dataset) return {};
    return {
      article_handle: root.dataset.bulletinArticleHandle || undefined,
      content_type: root.dataset.bulletinContentType || undefined,
      issue_number: root.dataset.bulletinIssueNumber || undefined,
      issue_label: root.dataset.bulletinIssueLabel || undefined,
      season: root.dataset.bulletinSeason || undefined,
    };
  }

  function classifyBulletinLink(link) {
    const allowedCategories = [
      'book_product',
      'external_editorial',
      'local_event',
      'standalone_essay',
      'store_announcement',
    ];
    const explicitCategory = link.dataset
      ? link.dataset.ncbBulletinLinkCategory || link.dataset.bulletinLinkCategory
      : undefined;

    let destination;
    try {
      destination = new URL(link.href, window.location.origin);
    } catch (error) {
      return undefined;
    }
    if (destination.protocol !== 'http:' && destination.protocol !== 'https:') return undefined;
    if (allowedCategories.indexOf(explicitCategory) !== -1) return explicitCategory;
    if (destination.hostname !== window.location.hostname) return 'external_editorial';

    const path = destination.pathname;
    if (/^\/products\//.test(path)) return 'book_product';
    if (/^\/(pages\/events|blogs\/events|collections\/events)(\/|$)/.test(path)) return 'local_event';
    if (/^\/(blogs\/news|collections|pages)(\/|$)/.test(path)) return 'store_announcement';
    return undefined;
  }

  function trackBulletinLinkClick(event) {
    const link = event.target.closest('a');
    if (!link) return;
    const root = link.closest('[data-ncb-bulletin-article]');
    if (!root) return;

    const linkCategory = classifyBulletinLink(link);
    if (!linkCategory) return;
    const destination = new URL(link.href, window.location.origin);
    const linkText = link.textContent ? link.textContent.trim().replace(/\s+/g, ' ').slice(0, 120) : undefined;
    capture('bulletin_link_clicked', Object.assign({}, getBulletinArticleProperties(root), {
      link_category: linkCategory,
      link_text: linkText,
      destination_host: destination.hostname,
      destination_path: destination.pathname,
    }));
  }

  function trackBulletinSignupAction(event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    const button = event.target.closest('.klaviyo-form-button[type="button"]');
    if (!button) return;
    const signup = button.closest('[data-bulletin-signup]');
    if (!signup) return;
    capture('bulletin_signup_form_submitted', {
      signup_location: signup.dataset.bulletinSignupLocation || 'unknown',
      submission_state: 'attempted',
    });
  }

  function bulletinSignupLocationFromFormId(formId) {
    const safeFormId = String(formId || '').trim();
    if (!/^[A-Za-z0-9_-]+$/.test(safeFormId) || typeof document.querySelectorAll !== 'function') return undefined;
    let mounts = [];
    try {
      mounts = Array.from(document.querySelectorAll('.klaviyo-form-' + safeFormId));
    } catch (error) {
      return undefined;
    }
    const locations = new Set();
    mounts.forEach(function (mount) {
      const shell = mount && typeof mount.closest === 'function'
        ? mount.closest('[data-bulletin-signup-shell][data-klaviyo-form-id]')
        : null;
      if (!shell || typeof shell.getAttribute !== 'function' || shell.getAttribute('data-klaviyo-form-id') !== safeFormId) return;
      const signup = typeof shell.closest === 'function' ? shell.closest('[data-bulletin-signup]') : null;
      if (!signup) return;
      const location = signup.dataset && signup.dataset.bulletinSignupLocation
        ? signup.dataset.bulletinSignupLocation
        : 'unknown';
      locations.add(location);
    });
    if (locations.size === 0) return undefined;
    // Klaviyo's documented submit event identifies a form ID, not a mounted instance.
    // Preserve attribution only when every matching Bulletin mount has the same location.
    return locations.size === 1 ? locations.values().next().value : 'unknown';
  }

  function trackKlaviyoFormSubmit(event) {
    const detail = event && event.detail;
    if (!detail || detail.type !== 'submit') return;
    const signupLocation = bulletinSignupLocationFromFormId(detail.formId || detail.formID);
    if (!signupLocation) return;
    capture('bulletin_signup_submitted', {
      signup_location: signupLocation,
      source: 'klaviyo_form',
    });
  }

  function trackBulletinFallbackSubmitted(event) {
    const detail = event && event.detail;
    capture('bulletin_signup_submitted', {
      signup_location: (detail && detail.signupLocation) || 'unknown',
      source: 'footer_fallback',
    });
  }

  function bindBulletinSignupSuccessTracking() {
    if (typeof window.addEventListener === 'function') {
      window.addEventListener('klaviyoForms', trackKlaviyoFormSubmit);
    }
    if (typeof document.addEventListener === 'function') {
      document.addEventListener('ncb:bulletin-signup-submitted', trackBulletinFallbackSubmitted);
    }
  }

  function bindTrackedClicks() {
    document.addEventListener('click', function (event) {
      try {
        trackProductCardClick(event);
      } catch (error) {}
      try {
        trackBestSellerLinkClick(event);
      } catch (error) {}
      try {
        trackBulletinLinkClick(event);
      } catch (error) {}
      try {
        trackBulletinSignupAction(event);
      } catch (error) {}
    });
  }

  function bindBulletinArticleAnalytics() {
    if (typeof document.querySelector !== 'function') return;
    const root = document.querySelector('[data-ncb-bulletin-article]');
    if (!root) return;

    const articleProperties = getBulletinArticleProperties(root);
    capture('bulletin_article_viewed', articleProperties);

    const content = root.querySelector('[data-ncb-bulletin-content]');
    if (!content || typeof content.getBoundingClientRect !== 'function') return;
    if (typeof window.addEventListener !== 'function') return;

    const seenDepths = new Set();
    const thresholds = [25, 50, 75, 100];
    let scheduled = false;
    let hasScrolled = false;
    let completed = false;

    function stopReadingDepthTracking() {
      completed = true;
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    }

    function measureReadingDepth() {
      scheduled = false;
      const rect = content.getBoundingClientRect();
      const height = rect.height || content.offsetHeight || 0;
      if (height <= 0) return;
      const progress = Math.max(0, Math.min(100, ((window.innerHeight - rect.top) / height) * 100));
      thresholds.forEach(function (depth) {
        if (progress < depth || seenDepths.has(depth)) return;
        seenDepths.add(depth);
        capture('bulletin_article_reading_depth', Object.assign({}, articleProperties, {
          depth_percent: depth,
        }));
      });
      if (seenDepths.size === thresholds.length) stopReadingDepthTracking();
    }

    function scheduleMeasurement() {
      if (scheduled || completed) return;
      scheduled = true;
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(measureReadingDepth);
      } else {
        measureReadingDepth();
      }
    }

    function handleScroll() {
      hasScrolled = true;
      scheduleMeasurement();
    }

    function handleResize() {
      if (hasScrolled) scheduleMeasurement();
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize);
  }

  function bindBulletinSignupAnalytics() {
    const signups = typeof document.querySelectorAll === 'function'
      ? Array.from(document.querySelectorAll('[data-bulletin-signup]'))
      : [];

    if (signups.length > 0 && isCaptureAllowed() && typeof window.IntersectionObserver === 'function') {
      const seen = new Set();
      const observer = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5 || seen.has(entry.target)) return;
          seen.add(entry.target);
          observer.unobserve(entry.target);
          capture('bulletin_signup_viewed', {
            signup_location: entry.target.dataset.bulletinSignupLocation || 'unknown',
          });
        });
      }, { threshold: [0.5] });
      signups.forEach(function (signup) { observer.observe(signup); });
    }

  }

  function collectionHandleFromSection(section) {
    const collection = section.querySelector('.collection');
    if (collection && collection.dataset.collectionHandle) return collection.dataset.collectionHandle;
    const link = section.querySelector('a[href*="/collections/"]');
    if (!link) return undefined;
    const match = new URL(link.href, window.location.origin).pathname.match(/^\/collections\/([^/]+)/);
    return match ? decodeURIComponent(match[1]) : undefined;
  }

  // A section counts as viewed once half of it is visible, or once it fills half
  // of the viewport. The second rule matters on mobile, where a 10-card,
  // 2-column collection grid is taller than two screens, so it can never reach
  // 50% of its own height and would never be recorded.
  function isMerchandisingSectionViewed(entry) {
    if (entry.intersectionRatio >= 0.5) return true;
    const viewportHeight = (entry.rootBounds && entry.rootBounds.height) || window.innerHeight || 0;
    const visibleHeight = entry.intersectionRect ? entry.intersectionRect.height : 0;
    return viewportHeight > 0 && visibleHeight >= viewportHeight * 0.5;
  }

  function observeMerchandisingSections() {
    if (!isCaptureAllowed() || window.location.pathname !== '/') return;
    if (typeof window.IntersectionObserver !== 'function') return;

    const sections = Array.from(document.querySelectorAll('#MainContent .shopify-section'));
    const seen = new Set();
    // Observers only fire when a threshold is crossed, so a fine-grained list is
    // needed for tall sections whose visible ratio tops out well below 0.5.
    const thresholds = [];
    for (let step = 0; step <= 20; step += 1) thresholds.push(step / 20);
    const observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || seen.has(entry.target)) return;
        if (!isMerchandisingSectionViewed(entry)) return;
        seen.add(entry.target);
        observer.unobserve(entry.target);
        capture('merchandising_section_viewed', {
          section_id: cleanSectionId(entry.target.id),
          collection_handle: collectionHandleFromSection(entry.target),
          homepage_position: sections.indexOf(entry.target) + 1,
        });
      });
    }, { threshold: thresholds });

    sections.forEach(function (section) {
      if (section.querySelector('.collection')) observer.observe(section);
    });
  }

  function bindMeasurementAaExposure() {
    if (!isCaptureAllowed()) return;
    if (typeof window.posthog.onFeatureFlags !== 'function') return;
    let captured = false;
    window.posthog.onFeatureFlags(function () {
      if (captured || typeof window.posthog.getFeatureFlag !== 'function') return;
      const variant = window.posthog.getFeatureFlag('storefront-measurement-aa-v1');
      if (variant !== 'control' && variant !== 'aa-treatment') return;
      captured = true;
      capture('storefront_measurement_aa_exposed', {
        flag_key: 'storefront-measurement-aa-v1',
        variant: variant,
      });
    });
  }

  window.ncbStorefrontAnalytics = {
    buildAddToCartProperties: buildAddToCartProperties,
    classifyBulletinLink: classifyBulletinLink,
    capture: capture,
    getAddContext: getAddContext,
    getBulletinArticleProperties: getBulletinArticleProperties,
  };

  bindTrackedClicks();
  bindBulletinArticleAnalytics();
  bindBulletinSignupAnalytics();
  bindBulletinSignupSuccessTracking();
  observeMerchandisingSections();
  bindMeasurementAaExposure();
})();
